import React, { useEffect, useState } from "react";
import imagesLogo from "../../assets/images/logo-toyota.jpeg";

function Footer() {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const onScroll = () => setOffset(window.pageYOffset);
    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <footer className="w3l-footer-66">
      <section className="footer-inner-main">
        <div className="footer-hny-grids py-5">
          <div className="container py-lg-4">
            <div className="text-txt">
              <div className="right-side">
                <div className="row sub-columns">
                  <div className="col-lg-4 col-md-6 sub-one-left pr-lg-4">
                    <a className="navbar-brand" href="/">
                      <img
                        src={imagesLogo}
                        alt="Your logo"
                        title="Your logo"
                        // style="height:50px;"
                      />
                    </a>
                    <p className="pr-lg-4">
                      An tâm bảo dưỡng vững bước hành trình.
                    </p>
                  </div>
                  <div className="col-lg-8 col-md-8 sub-one-left">
                    <div className="sub-two-right">
                      <h6
                        style={{
                          fontFamily:
                            "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",
                        }}
                      >
                        ĐƯỜNG DÂY NÓNG
                      </h6>
                      <ul>
                        <li>
                          <a href="tel:0866866501">
                            <span className="fa fa-phone mr-2"></span>
                            0866.866.501
                          </a>
                        </li>
                        <li>
                          <a href="mailto:truonggiang@gmail.com">
                            <span className="fa fa-envelope mr-2"></span>
                            truonggiang@gmail.com
                          </a>
                        </li>
                        <li>
                          <a>
                            <span className="fa fa-angle-right mr-2"></span>
                            Hotline Hỗ trợ tài chính: (84-28) 7309 0998
                          </a>
                        </li>
                        <li>
                          <a>
                            <span className="fa fa-angle-right mr-2"></span>
                            Hotline Bảo hiểm Toyota: 1900 633 384
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="below-section">
          <div className="container">
            <div className="copyright-footer">
              <div className="columns text-lg-left">
                <p>© 2022 Toyota Trường Giang. All rights reserved</p>
              </div>
            </div>
          </div>
        </div>
        <div className="btn-phone">
          <a href="tel:0866866501">
            <button
              className="btn-phone"
              title="0866866501"
              onClick={() => onTop()}
            >
              <span className="fa fa-phone" aria-hidden="true"></span>
            </button>
            <div className="btn-phone-text">0866 866 501</div>
          </a>
        </div>

        {offset > 350 && (
          <button className="btn-top" title="Go to top" onClick={() => onTop()}>
            <span className="fa fa-arrow-up" aria-hidden="true"></span>
          </button>
        )}
      </section>
    </footer>
  );
}

export default Footer;
